export default __webpack_public_path__ + "static/media/025-literature.b720bddd.svg";